import React from 'react';
import { Modal, ModalProps } from '@amzn/stencil-react-components/modal';
import { Button, ButtonVariant } from '@amzn/stencil-react-components/button';
import { Col, Row } from '@amzn/stencil-react-components/layout';
import { Text, H2 } from '@amzn/stencil-react-components/text';
import { Card } from '@amzn/stencil-react-components/card';
import useArb from '../../hooks/useArb';

interface LogoutConfirmationModalProps extends Omit<ModalProps, 'children' | 'close'> {
  onConfirm: () => void;
  onCancel: () => void;
  currentCandidateId?: string;
  newCandidateId?: string;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  onConfirm,
  onCancel,
  currentCandidateId,
  newCandidateId,
  ...props
}) => {
  const { t } = useArb('appStrings');

  if (!props.isOpen) {
    return null;
  }

  return (
    <Modal {...props} close={onCancel}>
      <Card>
        <Col gridGap={32}>
          <H2>{t('PHO-logout-confirmation-title', 'Session Conflict')}</H2>
          <Text color="var(--st-dt-color-text-secondary)">
            {t(
              'PHO-logout-confirmation-message',
              'An active session has been detected. Do you want to terminate the existing session and proceed with the new login?',
            )}
          </Text>
          <Row gridGap={12} justifyContent="flex-end">
            <Button variant={ButtonVariant.Secondary} onClick={onCancel}>
              {t('PHO-logout-confirmation-cancel', 'Cancel')}
            </Button>
            <Button variant={ButtonVariant.Primary} onClick={onConfirm}>
              {t('PHO-logout-confirmation-confirm', 'Force Logout Previous Session')}
            </Button>
          </Row>
        </Col>
      </Card>
    </Modal>
  );
};

export default LogoutConfirmationModal;
